import Vue from "vue";
// import "fullpage.js/vendors/scrolloverflow";
// import VueFullPage from "vue-fullpage.js";
import App from "./App.vue";
import {domain, clientId, audience} from "../auth_config.json";
import { Auth0Plugin } from "./auth";
import "./registerServiceWorker";
import {ClientTable} from 'vue-tables-2';

Vue.config.productionTip = false;

import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";

// import "fullpage.js/dist/fullpage.min.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import "bulma/css/bulma.min.css";
import "font-awesome/css/font-awesome.min.css";

Vue.use(Vuelidate);

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl ? appState.targetUrl : window.location.pathname
    );
  }
});

Vue.use(ClientTable, {}, false, 'bulma');

new Vue({
  router,
  store,
  render: (h) => h(App),
  provide: function() {
    return {
      eventBus: new Vue(),
    };
  },
}).$mount("#app");
